/*global $, define, dna getParams*/
define('core/factory/PerformanceMetricFactory',[
    'angular'
], function (angular) {
    'use strict';

    /*
     This factory is using and relying on the Performance API (https://developer.mozilla.org/en-US/docs/Web/API/Performance)
     All of our supported browsers should have this available (http://caniuse.com/#feat=nav-timing)
     */
    return angular.module('dnaApp').factory('PerformanceMetric', ['$rootScope', '$http', '$window', 'ConfigurationService', function PerformanceMetric($rootScope, $http, $window, ConfigurationService) {
        var PERFORMANCE_LOG_URL = '/secure/performance/log';
        var excludeAngularLoadTime = false;
        var timeUntilAngularLoaded;
        var timerStartTime;
        var nextRoute;
        var currentRoute;
        var fmpMarkHasBeenSet = false;
        var useInsightsSkeletonFmp = true;

        /*
         mark performance timer on routeChangeStart.
         If configSettings aren't available yet, which happens on initial load, start timer manually.
         */
        $rootScope.$on('$routeChangeStart', function ($event, next, current) {
            try {
                if (ConfigurationService.configSettings.enableClientForensicLogging === true) {
                    performance.startTimer(next, current);
                } else {
                    performance.startTimer(next, current, true);
                }

                /**
                 * If we have no current route and current wasn't redirected to
                 * If we have no next route
                 * And current's original path is not equal to next's original path
                 * Then we have had a route change that the performance timing will be set up for. In this case, we want to reset the fmp mark and no longer consider angular load time.
                 */
                if (current && next && !current.$$route.redirectTo && current.$$route.originalPath !== next.$$route.originalPath) {
                    fmpMarkHasBeenSet = false;
                    excludeAngularLoadTime = true;
                    useInsightsSkeletonFmp = false;
                }

                if (!excludeAngularLoadTime && $window.performance && $window.performance.now) {
                    timeUntilAngularLoaded = $window.performance.now();
                }
            } catch (e) {}
        });

        var performance = {
            getFmpMarkHasBeenSet: function() {
                return fmpMarkHasBeenSet;
            },
            measureTimer: function (timerName, timerType) {
                try {
                    if ($window.performance && ConfigurationService.configSettings.enableClientForensicLogging) {
                        var totalRuntime;
                        var totalRuntimeIncludesAngularLoadTime = false;

                        if (useInsightsSkeletonFmp && (!currentRoute || currentRoute.$$route.originalPath === '/') && nextRoute.$$route.originalPath === '/insights/:testGuid?') {
                            if ($window.performance.getEntriesByName) {
                                var fmpMarks = $window.performance.getEntriesByName('fmp');
                                if (fmpMarks && fmpMarks.length > 0) {
                                    totalRuntime = $window.performance.getEntriesByName('fmp')[0].startTime;
                                }
                            } else if ($window.dnaPerformanceFmpMark) {
                                totalRuntime = $window.dnaPerformanceFmpMark;
                            }
                            fmpMarkHasBeenSet = true;
                            useInsightsSkeletonFmp = false;
                        } else if ($window.performance.now) {
                            if (excludeAngularLoadTime) {
                                totalRuntime = $window.performance.now() - timerStartTime;
                            } else {
                                totalRuntime = $window.performance.now();
                                totalRuntimeIncludesAngularLoadTime = true;

                            }
                            if (timerType && timerType === 'FMP') {
                                fmpMarkHasBeenSet = true;
                            }
                        }

                        // Send time to PerformanceController
                        if (totalRuntime) {
                            var url = PERFORMANCE_LOG_URL + '?timerName=' + timerName;
                            url += '&totalRuntime=' + totalRuntime;
                            url += '&totalRuntimeIncludesAngularLoadTime=' + totalRuntimeIncludesAngularLoadTime;

                            if (totalRuntimeIncludesAngularLoadTime) {
                                url += '&timeUntilAngularLoaded=' + timeUntilAngularLoaded;
                            }

                            url += nextRoute ? '&nextRoute=' + nextRoute.$$route.originalPath : '&nextRoute=noRouteSet';
                            url += currentRoute ? '&currentRoute=' + currentRoute.$$route.originalPath : '&currentRoute=noRouteSet';
                            url += '&timerType=' + (timerType ? timerType : 'PERFORMANCE_MEASURE');

                            $http.get(url);
                        }
                    }
                } catch (e) {}
            },
            startTimer: function (next, current, startManually) {
                try {
                    if ($window.performance && $window.performance.now && ((ConfigurationService.configSettings.enableClientForensicLogging) || startManually)) {
                        timerStartTime = $window.performance.now();
                        nextRoute = next;
                        currentRoute = current;
                    }
                } catch (e) {}
            }
        };

        return performance;
    }]);
});

